import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type InputErrorType,
  type IMonthBucket,
} from "@b2bportal/core-types";

import { useDateRangePicker } from "@tenant/hotels";
import {
  Calendar,
  DatePickerButton,
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
  PickerType,
} from "@tenant/ui";

import clsx from "clsx";
import defaultStyles from "./DateRangePicker.module.scss";

export interface DateRangePickerComponentProps {
  startDate: string | undefined;
  endDate: string | undefined;
  onStartDateChangeHandler: (date: string | undefined) => void;
  onEndDateChangeHandler: (date: string | undefined) => void;
  onDoneClick?: () => void;
  onClose?: () => void;
  dialogTitle?: string;
  classNames?: {
    content?: string;
  };
  pricingProps?: {
    months?: IMonthBucket[];
    priceTagsElement?: JSX.Element;
    priceTags?: string[];
  };
  error?: InputErrorType;
  triggerButton?: JSX.Element;
  className?: string;
}
export const DateRangePicker = (props: DateRangePickerComponentProps) => {
  const COMPONENT_KEY = CoreHotelsComponent.DateRangePicker;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [_, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { context, handlers, text } = useDateRangePicker(props);

  return (
    <Dialog onClose={handlers.onClose} onOpen={handlers.onOpen}>
      <DialogTrigger asChild>
        {props.triggerButton ?? (
          <DatePickerButton
            startDate={context.stringStartDate}
            endDate={context.stringEndDate}
            startLabel={text.startDateLabel}
            endLabel={text.endDateLabel}
            hideSeparator={true}
            error={props.error}
            className={props.className}
          />
        )}
      </DialogTrigger>
      <DialogContent
        title={text.dialogTitle}
        className={clsx(cn("dialog-content"), props.classNames?.content)}
        fullScreen={context.dialogFullscreen}
        bottomFixedContent={
          <div
            className={cn("bottom-content", {
              "has-price-tags": props.pricingProps?.priceTagsElement != null,
            })}
          >
            {props.pricingProps?.priceTagsElement != null
              ? props.pricingProps?.priceTagsElement
              : null}
            <DialogClose asChild>
              <button
                className={cn("apply-button")}
                onClick={handlers.onDoneClick}
              >
                {text.dialogDone}
              </button>
            </DialogClose>
          </div>
        }
      >
        <Calendar
          className={cn("calendar")}
          viewType={context.calendarViewType}
          setStartDate={handlers.onStartDateChange}
          setEndDate={handlers.onEndDateChange}
          startDate={context.startDate}
          endDate={context.endDate}
          startDateLabel={text.startDateLabel}
          endDateLabel={text.endDateLabel}
          pickerType={PickerType.RANGE}
          priceTagsElement={<></>}
          months={props.pricingProps?.months ?? []}
          currency={""}
          priceTags={props.pricingProps?.priceTags ?? []}
        />
      </DialogContent>
    </Dialog>
  );
};
